import Compressor from "compressorjs";

export const getBase64 = (file) => {
  return new Promise((resolve) => {
    let baseURL = "";
    let reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = () => {
      baseURL = reader.result;
      resolve(baseURL);
    };
  });
};

export const MAX_UPLOAD_BYTES = 5 * 1024 * 1024; // 5 MB

/** Reject files over 5 MB before any compress/upload (client-side VAPT control). */
export const assertUnderUploadLimit = (file, label = "File") => {
  if (!file) {
    throw new Error(`${label} is required`);
  }
  if (file.size > MAX_UPLOAD_BYTES) {
    throw new Error(`${label} must be 5 MB or smaller`);
  }
  return true;
};

export const compressImage = (file, beta = false) => {
  return new Promise((resolve, reject) => {
    try {
      assertUnderUploadLimit(file, "Image");
    } catch (err) {
      reject(err);
      return;
    }
    if (!beta) {
      resolve(file);
      return;
    }
    new Compressor(file, {
      quality: 0.4,
      success: (compressedResult) => {
        if (compressedResult.size > MAX_UPLOAD_BYTES) {
          reject(new Error("Compressed file size exceeds 5 MB limit"));
        } else {
          resolve(compressedResult);
        }
      },
      error: (err) => reject(err),
    });
  });
};

export const dataURItoBlob = (dataURI) => {
  var byteString;

  if (dataURI.split(",")[0].indexOf("base64") >= 0)
    byteString = atob(dataURI.split(",")[1]);
  else byteString = unescape(dataURI.split(",")[1]);

  var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

  var ia = new Uint8Array(byteString.length);
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  var blob = new Blob([ia], { type: mimeString });
  return URL.createObjectURL(blob);
};

export const handleDownloadBase64PDF = (base64, fileName) => {
  const downloadLink = document.createElement("a");
  downloadLink.href = dataURItoBlob(base64);
  downloadLink.download = fileName;
  downloadLink.click();
};
